import styled from "styled-components";

import { colors, radii, shadows } from "shared/ui/tokens";

import { MOBILE_BREAKPOINT } from "features/IikoIntegration/constants";
import { IikoIntegrationStatusTone } from "features/IikoIntegration/types";

const DOT_COLORS: Record<IikoIntegrationStatusTone, string> = {
    idle: colors.fieldBorder,
    progress: colors.amber,
    connected: colors.success,
};

export const Card = styled.section`
    background: ${colors.surface};
    border-radius: ${radii.base};
    box-shadow: ${shadows.panel};
    padding: 20px 24px;
    display: flex;
    align-items: center;
    gap: 14px;

    @media (max-width: ${MOBILE_BREAKPOINT - 1}px) {
        display: block;
        padding: 16px;
    }
`;

export const Summary = styled.div`
    display: flex;
    align-items: center;
    gap: 14px;
    flex: 1 1 auto;
    min-width: 0;

    @media (max-width: ${MOBILE_BREAKPOINT - 1}px) {
        align-items: flex-start;
        gap: 12px;
    }
`;

export const Dot = styled.span<{ $tone: IikoIntegrationStatusTone }>`
    width: 10px;
    height: 10px;
    border-radius: 50%;
    flex: 0 0 auto;
    background: ${({ $tone }) => DOT_COLORS[$tone]};

    /* На узком вьюпорте текст переносится, и точка выравнивается по первой строке. */
    @media (max-width: ${MOBILE_BREAKPOINT - 1}px) {
        margin-top: 6px;
    }
`;

export const Text = styled.div`
    flex: 1 1 auto;
    min-width: 0;
`;

export const Title = styled.div`
    font-size: 0.9375rem;
    font-weight: 600;
    color: ${colors.textPrimary};
`;

export const Subtitle = styled.div`
    margin-top: 2px;
    font-size: 12px;
    color: ${colors.textSecondary};
`;

export const ToggleWrap = styled.div`
    flex: 0 0 auto;

    @media (max-width: ${MOBILE_BREAKPOINT - 1}px) {
        margin-top: 14px;
        padding-top: 14px;
        border-top: 1px solid ${colors.borderSofter};
    }
`;
